module.exports = __webpack_public_path__ + "static/media/logo_full.b204ab77.png";